import { Text } from '@chakra-ui/react';
import TlTxnDetailsCard from '@components/RdaDashboard/Transactions/Details/TlTxnDetails';
import CbTxnDetailsCard from '@components/RdaDashboard/Transactions/Details/CbTxnDetails';
import YblTxnDetailsCard from '@components/RdaDashboard/Transactions/Details/YblTxnDetails';
import OverallTxnDetailsCard from '@components/RdaDashboard/Transactions/Details/OverallTxnDetails';


const TxnDetailsCard = (props) => {
  const { cardType, ...componentProps } = props;

  switch (cardType) {
    case 'OVERALL':
      return <OverallTxnDetailsCard {...componentProps} />;

    case 'TRUE_LAYER':
      return <TlTxnDetailsCard {...componentProps} />;

    case 'CLEAR_BANK':
      return <CbTxnDetailsCard {...componentProps} />;

    case 'YBL':
      return <YblTxnDetailsCard {...componentProps} />;

    default:
      return (
        <>
          <Text color={'gray.500'} fontSize={'md'}>
            Default component
          </Text>
        </>
      );
  }
};

export default TxnDetailsCard;
